import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Login from './components/Login';
import ChangePassword from './components/ChangePassword';
import Dashboard from './components/Dashboard';
import CreateRequest from './components/CreateRequest';
import RequestList from './components/RequestList';
import RequestDetail from './components/RequestDetail';
import AdminPanel from './components/AdminPanel';
import UserProfile from './components/UserProfile';
import SenderInbox from './components/SenderInbox';
import SharedWithMe from './components/SharedWithMe';
import OrganizationPanel from './components/OrganizationPanel';
import Layout from './components/Layout';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import OrgGate from './components/OrgGate';
import OrgPicker from './components/OrgPicker';
import InviteAccept from './components/InviteAccept';

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/invite" element={<InviteAccept />} />
        <Route path="/change-password" element={<ChangePassword forced />} />
        <Route path="/" element={
          <PrivateRoute>
            <OrgGate>
              <Layout />
            </OrgGate>
          </PrivateRoute>
        }>
          <Route index element={<Dashboard />} />
          <Route path="org-picker" element={<OrgPicker />} />
          <Route path="requests" element={<RequestList />} />
          <Route path="requests/new" element={<CreateRequest />} />
          <Route path="requests/:id" element={<RequestDetail />} />
          <Route path="inbox" element={<SenderInbox />} />
          <Route path="shared" element={<SharedWithMe />} />
          <Route path="investigations/:id" element={<RequestList />} />
          <Route path="organization" element={<OrganizationPanel />} />
          <Route path="profile" element={<UserProfile />} />
          <Route path="admin" element={
            <AdminRoute>
              <AdminPanel />
            </AdminRoute>
          } />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
